export const GOOGLE_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2";
export const APPLE_STORE_LINK =
  "https://apps.apple.com/pl/app/google-authenticator/id388497605";
